<template>
  <div class="anonce">
    <div class="anonce__body" v-if="isShow">
      <ul class="uk-grid-match" uk-grid>
        <li class="uk-width-1-4@s uk-width-1-5@m">
          <div class="anonce__img">
            <img :src="'storage/app/media/' + site_settings.anonce_image" alt="">
          </div>
        </li>
        <li class="uk-width-3-4@s uk-width-4-5@m">
          <div>
            <div class="anonce__content" v-show="step === 1">
              <div class="anonce__title">{{ site_settings.anonce_title }}</div>
              <div class="anonce__desc" v-html="site_settings.anonce_desc"></div>
              <div class="anonce__podp">{{ site_settings.anonce_podp }}</div>
              <div class="anonce__button" v-if="site_settings.anonce_hasbutton">
                <a :href="site_settings.anonce_ink" target="_blank">{{ site_settings.anonce_button ? site_settings.anonce_button : 'Зайти в конференцию'}}</a>
                <!--<button class="uk-button" @click="step++">Записаться на урок!</button>-->
                <!--<a href="#" @click="onReject">Отказаться от предложения</a>-->
              </div>
            </div>

            <div class="anonce__content" v-show="step === 2">
              <div class="anonce__title">Отлично! Заполните данные, чтобы получить подарок!</div>
              <div class="anonce__form">
                <label>
                  <span>Введите имя контактного лица (родителя)</span>
                  <input v-model="name" type="text" class="uk-input" placeholder="Имя">
                </label>
                <label>
                  <span>Введите телефон для связи</span>
                  <input type="tel" v-model="phone" class="uk-input" placeholder="Ваш телефон">
                </label>
                <div class="anonce__button">
                  <button class="uk-button" @click="onSend">Отправить!</button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import { mapGetters } from 'vuex'

export default {
  name: "anonce",
  inject: ['site_settings', 'http'],
  data() {
    return {
      step: 1,
      name: '',
      phone: '',
      isShow: true
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  async mounted() {
    this.isShow = +this.site_settings.has_anonce ? true : false
  },
  methods: {
    onReject() {
      swal({
        title: "Вы точно хотите отказаться от бесплатного урока?",
        icon: "warning",
        buttons: ['Нет', 'Да, хочу отказаться'],
        dangerMode: true,
      })
      .then(async (choise) => {
        if (choise) {
          this.$root.wait = true;
          let res = await this.http.post('onRejectGiftLesson', { user_id: this.user.id }).then(res => res.data) 
          this.$root.wait = false;
          this.user.property = res.property;
          this.isShow = false
        }
      });
    },
    async onSend() {
      if (this.name && this.phone) {
        let data = {
          parent_name: this.name,
          phone: this.phone,
          student_name: this.user.name,
          user_id: this.user.id
        }
        let res = await this.http.post('onTakeGiftLesson', data).then(res => res.data);
        this.user.property = res.property;
        this.isShow = false
        swal('Спасибо! Мы скоро с вами свяжемся!', "", "success");
      } else {
        swal('Проверьте введенные данные', "", "warning");
      }
    }
  }
}
</script>